import Role from '../enums/role';
import RoleCategory from '../enums/roleCategory';
const roleMap = [
    { id: Role.KpmgAdmin, name: 'ROLE.KPMG_ADMIN' },
    { id: Role.ClientAdmin, name: 'ROLE.KPMG_CLIENT' },
    {
        id: Role.Universal,
        name: 'ROLE.UNIVERSAL',
        category: RoleCategory.Contributor,
        displaySortOrder: 1
    },
    {
        id: Role.Creator,
        name: 'ROLE.CREATOR',
        category: RoleCategory.Contributor,
        displaySortOrder: 2
    },
    {
        id: Role.Verifier,
        name: 'ROLE.VERIFIER',
        category: RoleCategory.Contributor,
        displaySortOrder: 3
    },
    {
        id: Role.Approver,
        name: 'ROLE.APPROVER',
        category: RoleCategory.Contributor,
        displaySortOrder: 4
    },
    {
        id: Role.Watcher,
        name: 'ROLE.WATCHER',
        category: RoleCategory.Inspector,
        displaySortOrder: 5
    }
];
export const getRoleNameById = (id) => roleMap.find((item) => item.id === id).name;
export const getRoleCategoryById = (id) => roleMap.find((item) => item.id === id).category;
const getRoleDisplaySortOrderById = (id) => roleMap.find((item) => item.id === id).displaySortOrder;
export const getSortedRoles = (roles) => roles.sort((a, b) => getRoleDisplaySortOrderById(a) - getRoleDisplaySortOrderById(b));
